import { render, staticRenderFns } from "./PopupIframe.vue?vue&type=template&id=b99bcb52&"
import script from "./PopupIframe.vue?vue&type=script&lang=js&"
export * from "./PopupIframe.vue?vue&type=script&lang=js&"
import style0 from "./PopupIframe.vue?vue&type=style&index=0&id=b99bcb52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports